<template>
  <div class="tab">
    <cube-tab-bar
            :useTransition=false
            :showSlider=true
            v-model="selectedLabel"
            :data="tabs"
            ref="tabBar"
            class="border-bottom-1px"
    >
    </cube-tab-bar>
    <div class="slide-wrapper">
      <cube-slide
              :loop=false
              :auto-play=false
              :show-dots=false
              :initial-index="index"
              ref="slide"
              :options="slideOptions"
              @scroll="onScroll"
              @change="onChange"
      >
        <cube-slide-item v-for="(tab,index) in tabs" :key="index">
          <component ref="component" :is="tab.component" :data="tab.data" @tempGoods="tempGoods"></component>
        </cube-slide-item>
      </cube-slide>
    </div>
    <shopping v-if="isShowcartInfo" :ifInStore="true" :isShowcartInfo="isShowcartInfo" @add="onGoodsAdd" :tempGoods="tempGoods_child"></shopping>
  </div>
</template>

<script>
import shopping from '../goodsdetail/child/Shopping'
import { mapState } from 'vuex'
import { Toast } from 'mint-ui'

export default {
  name: 'StoredetailTab',
  components: {
    shopping,
  },
  props: {
    tabs: {
      type: Array,
      default () {
        return []
      }
    },
    initialIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      index: this.initialIndex,
      slideOptions: {
        listenScroll: true,
        probeType: 3,
        directionLockThreshold: 0
      },
      tempGoods_child: null
    }
  },
  computed: {
    ...mapState({
      // 是否显示购物车浮层
      isShowcartInfo: state => state.goodsdetail.isShowcartInfo,
      user: state => state.member.info
    }),
    selectedLabel: {
      get () {
        return this.tabs[this.index].label
      },
      set (newVal) {
        if (newVal === '優惠' && !this.user) {
          Toast(this.$t('guest.need_more_please_login'))
          return;
        }

        this.index = this.tabs.findIndex((value) => {
          return value.label === newVal
        })
      }
    }
  },
  mounted () {
    this.onChange(this.index)
  },
  methods: {
    tempGoods(data) {
      this.tempGoods_child = data
    },
    onGoodsAdd(goods,mnumber) {
      const instance = this.$refs.component[this.initialIndex]
      if(instance) {
        instance.onGoodsAdd(goods,mnumber)
      }
    },
    onScroll (pos) {
      const tabBarWidth = this.$refs.tabBar.$el.clientWidth
      const slideWidth = this.$refs.slide.slide.scrollerWidth
      const transform = -pos.x / slideWidth * tabBarWidth
      this.$refs.tabBar.setSliderTransform(transform)
    },
    onChange (current) {
      this.index = current
      const instance = this.$refs.component[current]
      if (instance && instance.fetch) {
        instance.fetch()
      }
    }
  }
}
</script>

<style >
  .tab{    -ms-flex-direction: column;
    -webkit-box-direction: normal;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .tab .cube-tab-bar {
    padding-bottom: 10px;
    background: white;
  }
  .tab .cube-tab{
    padding: 0.5rem 0;
    font-size:0.7rem;
    background-color: #f4c41e;
    margin: 0px 10px;
    border-radius: 8px;
    color: white;
    box-shadow: 0px 2px 0px 0px #808080;
  }
  .tab  .cube-tab_active {
    color: white;
    background-color: #808080;
  }
  .tab .cube-tab-bar-slider{background-color: transparent; height: 0.15rem;}
  .slide-wrapper{
    -ms-flex: 1;
    -webkit-box-flex: 1;
    flex: 1;
    overflow: hidden;
}
</style>
